import type {
  ReportFormData,
  SelectField as SelectFieldType,
} from '@/screens/ReportCreation/reportCreation.types';
import { FieldValues, useController } from 'react-hook-form';
import { YStack } from 'tamagui';
import { FieldError } from '../FieldError';
import type { ControlledFieldController } from '../formController.types';
import { SelectField } from './SelectField';

interface ControlledSelectFieldProps<FormValues extends FieldValues> {
  field: SelectFieldType;
  formController: ControlledFieldController<FormValues>;
}

export const ControlledSelectField = <
  FormValues extends FieldValues = ReportFormData,
>({
  field,
  formController,
}: ControlledSelectFieldProps<FormValues>): React.ReactElement => {
  const { field: controllerField, fieldState } = useController<FormValues>({
    ...formController,
  });

  const value =
    typeof controllerField.value === 'string' ? controllerField.value : '';

  return (
    <YStack gap="$1">
      <SelectField
        label={field.label}
        options={field.options}
        value={value || ''}
        onValueChange={controllerField.onChange}
        placeholder={field.placeholder}
        required={field.required}
      />
      <FieldError message={fieldState.error?.message} />
    </YStack>
  );
};
